import { render } from "./SingleImageOrVideo.vue?vue&type=template&id=2aa7760c&scoped=true"
import script from "./SingleImageOrVideo.vue?vue&type=script&lang=js"
export * from "./SingleImageOrVideo.vue?vue&type=script&lang=js"

import "./SingleImageOrVideo.vue?vue&type=style&index=0&id=2aa7760c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa7760c"]])

export default __exports__